module.exports = __webpack_public_path__ + "img/DW365-145.d0449724.jpg";